class CustomCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }

  initializeSwiper() {
    const swiperElement = this.querySelector('.swiper');
    if (!swiperElement) return;


    const isProductImageCarousel = this.classList.contains('product-image-carousel');
    

    const config = {

      slidesPerView: isProductImageCarousel ? 1 : 3,
      spaceBetween: isProductImageCarousel ? 0 : 10,
      centeredSlides: false,
      allowTouchMove: true,
      watchOverflow: true,
      breakpoints: isProductImageCarousel ? {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
          allowTouchMove: true
        }
      } : {
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
          centeredSlides: false
        }
      },


      loop: this.dataset.loop === 'true',


      autoplay: this.dataset.autoplay === 'true' ? {
        delay: parseInt(this.dataset.autoplayDelay) || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,


      navigation: this.dataset.navigation === 'true' ? {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      } : false,


      pagination: this.dataset.pagination === 'true' ? {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true
      } : false,


      grabCursor: true,
      watchOverflow: true,
      

      on: {
        init: () => {
          this.classList.add('swiper-initialized');
        },
        slideChange: () => {

          this.pauseAllVideos();
        }
      }
    };

    // Initialize Swiper
    this.swiper = new Swiper(swiperElement, config);


    this.addEventListeners();


    if (isProductImageCarousel) {
      this.setupProductImageNavigation();
    }
  }

  addEventListeners() {

    if (this.dataset.autoplay === 'true') {
      this.addEventListener('mouseenter', () => {
        if (this.swiper && this.swiper.autoplay) {
          this.swiper.autoplay.stop();
        }
      });

      this.addEventListener('mouseleave', () => {
        if (this.swiper && this.swiper.autoplay) {
          this.swiper.autoplay.start();
        }
      });
    }


    this.addEventListener('keydown', (e) => {
      if (!this.swiper) return;
      
      switch(e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          this.swiper.slidePrev();
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.swiper.slideNext();
          break;
      }
    });


    this.setAttribute('tabindex', '0');
  }

  setupProductImageNavigation() {
    const prevBtn = this.parentElement.parentElement.querySelector('button[aria-label="Previous image"]');
    const nextBtn = this.parentElement.parentElement.querySelector('button[aria-label="Next image"]');

    if (prevBtn && nextBtn && this.swiper) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.swiper.slidePrev();
      });

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.swiper.slideNext();
      });
    }
  }

  pauseAllVideos() {
    const videos = this.querySelectorAll('video');
    videos.forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });
  }


  slideNext() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  slidePrev() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  slideTo(index) {
    if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  startAutoplay() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.start();
    }
  }

  stopAutoplay() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.stop();
    }
  }

  updateConfig(newConfig) {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
    

    Object.keys(newConfig).forEach(key => {
      this.dataset[key] = newConfig[key];
    });
    

    this.initializeSwiper();
  }
}


customElements.define('custom-carousel', CustomCarousel);
